<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>
    {{ "MasterData.EditCatalogItemModal.Title" | i18nextEager }}
  </ng-template>
  <ng-template #content>
    <form [formGroup]="form">
      <div class="flex flex-col gap-lg w-full">
        @for (group of nameTranslations.controls; track group.controls.languageCode.value) {
          <div [formGroup]="group">
            <doka-text-field
              [frontDecoText]="group.controls.languageCode.value.toUpperCase()"
              formControlName="value"
              [attr.data-testid]="'edit-catalog-item-name-input-' + group.controls.languageCode.value"
              [label]="'MasterData.EditCatalogItemModal.Name' | i18nextEager"
              [placeholder]="'Common.Placeholder' | i18nextEager"
            />
          </div>
        }
      </div>
    </form>
  </ng-template>
  <ng-template #footer>
    <div class="flex flex-col gap-sm w-full">
      <div class="flex w-full gap-md px-6 pt-4 items-center justify-end">
        <doka-button
          [disabled]="isLoading()"
          (click)="closeModal()"
          color="secondary"
          data-testid="edit-catalog-item-cancel-button"
          >{{ "Common.Cancel" | i18nextEager }}</doka-button
        >
        <doka-button
          type="submit"
          [disabled]="form.invalid || isLoading() || nameTranslations.length === 0"
          (click)="submit()"
          color="primary"
          data-testid="edit-catalog-item-save-button"
        >
          {{ "Common.Save" | i18nextEager }}
        </doka-button>
      </div>
    </div>
  </ng-template>
</doka-modal-wrapper>
